/* Product page: variants, gallery, price, availability.

   Everything it needs is already in the page - the variant list is rendered as
   JSON by main-product.liquid - so choosing a colour costs no request and
   cannot show a stale price.

   The options are real radio inputs, so the form still submits the right thing
   with JavaScript off; this only keeps the price, the picture and the button in
   step with them. */
(function () {
  'use strict';

  var main = document.getElementById('pdpImage');
  var data = document.getElementById('pdpVariants');
  var idField = document.getElementById('pdpVariantId');

  /* ---- gallery thumbnails (work with or without variants) ---- */
  var thumbs = document.querySelectorAll('.pdp-thumb');
  var shown = 0;

  /* Swap only once the new picture is decoded, so a click never shows a blank
     frame - and since every picture is fetched ahead (below), that is instant. */
  var show = function (src, alt, full) {
    var next = new Image();
    next.src = src;
    var swap = function () {
      main.src = src;
      if (alt) main.alt = alt;
      if (full) main.dataset.full = full;
      /* srcset would otherwise win over the src we just set */
      main.removeAttribute('srcset');
    };
    (next.decode ? next.decode() : Promise.resolve()).then(swap, swap);
  };

  if (main && thumbs.length) {
    Array.prototype.forEach.call(thumbs, function (t, i) {
      t.addEventListener('click', function () {
        if (!t.dataset.src) return;
        shown = i;
        show(t.dataset.src, t.dataset.alt, t.dataset.full);
        Array.prototype.forEach.call(thumbs, function (o) {
          o.classList.toggle('is-on', o === t);
        });
      });
    });

    /* Fetch every gallery picture once the page itself has finished, so
       switching never waits on the network. */
    var warm = function () {
      Array.prototype.forEach.call(thumbs, function (t) {
        if (t.dataset.src) new Image().src = t.dataset.src;
      });
    };
    if (document.readyState === 'complete') warm();
    else window.addEventListener('load', warm);
  }

  /* ---- full-screen viewer: magnifier or the picture itself opens it ---- */
  var zoom = document.getElementById('pdpZoom');
  var zoomImg = document.getElementById('pdpZoomImg');
  var mag = document.getElementById('pdpMag');
  if (main && zoom && zoomImg && zoom.showModal) {
    var strip = zoom.querySelectorAll('[data-zoom-to]');
    var zoomTo = function (i) {
      if (thumbs.length) {
        shown = (i + thumbs.length) % thumbs.length;
        thumbs[shown].click();              /* keeps the page gallery in step */
        zoomImg.src = thumbs[shown].dataset.full || thumbs[shown].dataset.src;
      } else {
        zoomImg.src = main.dataset.full || main.src;
      }
      zoomImg.alt = main.alt;
      Array.prototype.forEach.call(strip, function (b, n) {
        b.classList.toggle('is-on', n === shown);
        if (n === shown && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    };
    var open = function () { zoom.showModal(); zoomTo(shown); };
    main.addEventListener('click', open);
    if (mag) mag.addEventListener('click', open);
    zoom.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-zoom],[data-zoom-to]') : null;
      if (!t) return;
      if (t.hasAttribute('data-zoom-to')) zoomTo(parseInt(t.dataset.zoomTo, 10));
      else if (t.dataset.zoom === 'close') zoom.close();
      else zoomTo(shown + parseInt(t.dataset.zoom, 10));
    });
    zoom.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') zoomTo(shown + 1);
      if (e.key === 'ArrowLeft') zoomTo(shown - 1);
    });
  }

  /* ---- variants ---- */
  if (!data || !idField) return;

  var variants;
  try { variants = JSON.parse(data.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  var priceEl = document.getElementById('pdpPrice');
  var colourEl = document.getElementById('pdpColour');
  var addBtn = document.getElementById('pdpAdd');
  var inputs = document.querySelectorAll('.opt-in');
  if (!inputs.length) return;

  var soldOut = addBtn ? addBtn.dataset.soldOutLabel || 'Sold out' : 'Sold out';
  var addLabel = addBtn ? addBtn.textContent.trim() : '';

  var chosen = function () {
    /* one value per option position, in position order */
    var out = [];
    Array.prototype.forEach.call(inputs, function (i) {
      if (!i.checked) return;
      out[parseInt(i.dataset.optionPosition, 10) - 1] = i.value;
    });
    return out;
  };

  var match = function (want) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < want.length; j++) {
        if (want[j] !== undefined && v.options[j] !== want[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  var apply = function () {
    var want = chosen();
    var v = match(want);

    if (colourEl && want[0]) colourEl.textContent = want[0];

    /* A combination that does not exist is a real state, not an error: say so
       rather than silently adding something else to the bag. */
    if (!v) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      return;
    }

    idField.value = v.id;

    if (priceEl) {
      priceEl.innerHTML = v.on_sale && v.compare
        ? v.price + ' <s>' + v.compare + '</s>'
        : v.price;
    }

    if (v.image && main) {
      main.src = v.image;
      main.removeAttribute('srcset');
    }

    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? (addLabel || 'Add to Cart') : soldOut;
      addBtn.classList.remove('added');
    }
  };

  Array.prototype.forEach.call(inputs, function (i) {
    i.addEventListener('change', apply);
  });

  /* keep the label in step if the page was loaded on a ?variant= url */
  apply();
})();
